import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { QuintsApiUrlResponse } from '@modules/quints-api/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  QUINTS_API_URLS_API_URL,
  QUINTS_API_URLS_PERMISSIONS,
  QUINTS_API_URLS_QUERY_KEY,
} from '@modules/quints-api/constants';

export default function useQuintsApiUrlsListQuery():
IContextQueryResult<QuintsApiUrlResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [QUINTS_API_URLS_QUERY_KEY],
    queryFn: () => fetchGet<QuintsApiUrlResponse>(
      QUINTS_API_URLS_API_URL,
      {
        permission: QUINTS_API_URLS_PERMISSIONS.SHOW,
      },
    ),
  });
}
